var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnKakao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 44,
    viewBox: "0 0 137 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_65_1156)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 129,
    height: 36,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 3.5,
    width: 128,
    height: 35,
    rx: 3.5,
    stroke: "#FFDD00",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1665 3H8.83348C6.16402 3 4 5.16402 4 7.83348V34.1665C4 36.836 6.16402 39 8.83348 39H35.1665C37.836 39 40 36.836 40 34.1665V7.83348C40 5.16402 37.836 3 35.1665 3Z",
    fill: "#FFDD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 7.91895C15.1692 7.91895 9.63171 13.041 9.63171 19.3593C9.63171 24.0257 11.5862 26.2533 14.2629 28.284L14.2757 28.2895V33.7659C14.2758 33.8241 14.2921 33.8812 14.3227 33.9307C14.3533 33.9803 14.3971 34.0204 14.4491 34.0465C14.5012 34.0726 14.5595 34.0838 14.6175 34.0787C14.6756 34.0737 14.731 34.0526 14.7778 34.0179L19.468 30.5341L19.5689 30.5779C20.3708 30.7256 21.1846 30.7997 22 30.7995C28.8309 30.7995 34.3683 25.6774 34.3683 19.3593C34.3683 13.0411 28.8309 7.91895 22 7.91895ZM17.854 22.2582C19.066 22.2582 20.1035 21.5325 20.4152 20.4112H22.2086C21.77 22.5691 20.0908 23.9833 17.854 23.9833C15.2546 23.9833 13.1933 22.0447 13.1933 19.3463C13.1933 16.6479 15.2546 14.7094 17.854 14.7094C20.1134 14.7094 21.8043 16.1519 22.222 18.3468H20.434C20.162 17.1534 19.09 16.4097 17.854 16.4097C16.1061 16.4097 14.9435 17.6566 14.9435 19.3463C14.9381 19.7301 15.0097 20.1111 15.154 20.4667C15.2983 20.8223 15.5125 21.1455 15.7838 21.4169C16.0551 21.6884 16.3781 21.9027 16.7337 22.0472C17.0893 22.1917 17.4702 22.2635 17.854 22.2582ZM29.6699 23.8054H28.0265V20.0983C28.0265 19.2447 27.5297 18.786 26.7653 18.786C25.9119 18.786 25.3641 19.3083 25.3641 20.3656V23.8054H23.7201V14.7382H25.3641V18.1489C25.7589 17.5503 26.3961 17.2572 27.2621 17.2572C27.9628 17.2572 28.5362 17.4864 28.982 17.9578C29.4407 18.4293 29.6699 19.0662 29.6699 19.8942V23.8054Z",
    fill: "#231815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1152 18.1582C52.1152 20.0586 53.0039 22.041 54.7129 22.9297L53.9746 23.9004C52.792 23.2715 51.9648 22.1025 51.5273 20.7148C51.083 22.1914 50.2627 23.4697 49.0801 24.1602L48.3145 23.2031C49.9961 22.2188 50.8848 20.127 50.8984 18.1582V17.707H48.6289V16.627H50.8984V14.8496H52.1152V16.627H54.3438V17.707H52.1152V18.1582ZM59.0332 14.4121V26.6621H57.7891V20.373H56.3262V26.0605H55.0957V14.6445H56.3262V19.2793H57.7891V14.4121H59.0332ZM62.5605 14.9727V19.1699C64.3311 19.1562 65.9375 19.0537 67.6875 18.7324L67.8652 19.7852C65.9102 20.1543 64.1875 20.2637 62.2324 20.25H61.2754V14.9727H62.5605ZM70.7637 14.4121V20.7148H69.4648V17.4062H66.1016V16.3535H69.4648V14.4121H70.7637ZM70.7637 21.248V24.3105H64.0645V25.459H71.1602V26.5117H62.7793V23.3125H69.4648V22.2734H62.752V21.248H70.7637ZM85.6113 14.4121V19.1562H87.5801V20.25H85.6113V26.6621H84.3125V14.4121H85.6113ZM77.8184 15.4375V18.582H81.0586V15.4375H82.3438V23.75H76.5332V15.4375H77.8184ZM77.8184 22.6836H81.0586V19.6074H77.8184V22.6836ZM99.3789 24.1055V25.1992H88.168V24.1055H93.1035V21.959H89.5352V18.0625H96.7266V16.3398H89.5078V15.2734H98.0117V19.1016H90.8203V20.8926H98.2988V21.959H94.3887V24.1055H99.3789ZM109.811 14.4121V19.293H111.711V20.373H109.811V26.6484H108.512V14.4121H109.811ZM106.611 15.6973C106.598 19.2383 105.039 22.3965 101.006 24.3926L100.281 23.3809C103.351 21.8496 105.019 19.6348 105.285 16.7773H100.896V15.6973H106.611ZM122.553 14.4121V26.6621H121.24V14.4121H122.553ZM118.902 15.7246C118.902 19.3066 117.371 22.4238 113.174 24.4336L112.49 23.3809C115.751 21.8291 117.337 19.6211 117.59 16.7637H113.078V15.7246H118.902Z",
    fill: "#171717",
    fillOpacity: 0.87
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_65_1156",
    x: 0,
    y: 0,
    width: 137,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_65_1156"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_65_1156",
    result: "effect2_dropShadow_65_1156"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_65_1156",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnKakao);
export default __webpack_public_path__ + "static/media/btn_kakao.e64a96b266462b8e2fe6804b64a1ba57.svg";
export { ForwardRef as ReactComponent };